import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import Filters from './Table/Filters';
import columns from './Table/columns';
import data from './Table/data';

import { useContext } from './Context';

export default function Table() {
  const { dispatch, actions, state } = useContext();

  const [keyword, setKeyword] = useState('');
  const [filterDate, setFilterDate] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);

  useEffect(() => {
    actions.load(dispatch, { affiliateId: state.affiliateId });
  }, []);

  return (
    <>
      <Filters
        keyword={keyword}
        setKeyword={setKeyword}
        filterDate={filterDate}
        setFilterDate={setFilterDate}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
      />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={data(state.payments, keyword, filterDate, filterStatus) || []}
          noDataComponent={(
            <div className="mt20">
              {state.payments == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
    </>
  );
}
